(function () {
  "use strict";

  if (window.BellwetherNativeFilterPolish) return;
  window.BellwetherNativeFilterPolish = true;

  var canonicalCategories = new Map([
    "antiques and collectibles", "Antiques & Collectibles",
    "architecture", "Architecture",
    "arts and photography", "Arts & Photography",
    "biography and autobiography", "Biography & Autobiography",
    "business", "Business",
    "childrens books", "Children's Books",
    "comics and graphic novels", "Comics & Graphic Novels",
    "computers and technology", "Computers & Technology",
    "cooking", "Cooking",
    "crafts and hobbies", "Crafts & Hobbies",
    "design", "Design",
    "education", "Education",
    "fantasy", "Fantasy",
    "fiction", "Fiction",
    "games and activities", "Games & Activities",
    "health and wellness", "Health & Wellness",
    "history", "History",
    "home and garden", "Home & Garden",
    "horror", "Horror",
    "language arts", "Language Arts",
    "literature", "Literature",
    "manga", "Manga",
    "mystery and thriller", "Mystery & Thriller",
    "philosophy", "Philosophy",
    "psychology", "Psychology",
    "reference", "Reference",
    "religion and spirituality", "Religion & Spirituality",
    "romance", "Romance",
    "science and nature", "Science & Nature",
    "science fiction", "Science Fiction",
    "self help", "Self-Help",
    "society and politics", "Society & Politics",
    "sports and outdoors", "Sports & Outdoors",
    "travel", "Travel",
    "true crime", "True Crime",
    "young adult", "Young Adult"
  ].reduce(function (entries, value, index, values) {
    if (index % 2 === 0) entries.push([value, values[index + 1]]);
    return entries;
  }, []));

  var bindingAliases = new Map([
    ["board book", "Board Book"], ["board_book", "Board Book"], ["card book", "Board Book"], ["rag book", "Board Book"],
    ["flexibound", "Flexibound"],
    ["hardcover", "Hardcover"], ["hard cover", "Hardcover"], ["hardback", "Hardcover"], ["tankobon hardcover", "Hardcover"], ["imitation leather", "Hardcover"],
    ["library", "Library Binding"], ["library binding", "Library Binding"], ["library_binding", "Library Binding"],
    ["mass market", "Mass Market Paperback"], ["mass_market", "Mass Market Paperback"], ["mass market paperback", "Mass Market Paperback"],
    ["paperback", "Paperback"], ["softcover", "Paperback"], ["soft cover", "Paperback"], ["trade paperback", "Paperback"], ["tankobon softcover", "Paperback"], ["tankobon_softcover", "Paperback"], ["perfect", "Paperback"], ["paperback bunko", "Paperback"], ["pocket book", "Paperback"], ["roughcut", "Paperback"],
    ["spiral bound", "Spiral Bound"], ["spiral_bound", "Spiral Bound"], ["hardcover spiral", "Spiral Bound"], ["plastic comb", "Spiral Bound"], ["loose leaf", "Spiral Bound"]
  ]);

  var conditionOrder = ["New", "Like New", "Very Good", "Good", "Acceptable"];

  function isCollectionPage() {
    return /^\/collections(?:\/|$)/.test(window.location.pathname);
  }

  function isSearchPage() {
    return /^\/search(?:\/|$)/.test(window.location.pathname);
  }

  function isWorkerPage() {
    return Boolean(document.querySelector("[data-bw-hybrid-catalog-config]"));
  }

  function workerConfig() {
    var node = document.querySelector("[data-bw-hybrid-catalog-config]");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return {};
    }
  }

  function selectedSort() {
    var explicit = new URLSearchParams(window.location.search).get("sort_by");
    if (explicit) return explicit;

    if (isWorkerPage()) {
      var config = workerConfig();
      var configured = String(config.defaultSort || config.sort || "").trim();
      if (configured) return configured;
      if (isCollectionPage()) return "sales-rank";
    }

    var checked = document.querySelector('input[name="sort_by"]:checked');
    if (checked && checked.value) return checked.value;

    return isSearchPage() ? "most-relevant" : "manual";
  }

  function unsupportedWorkerSort(value) {
    if (!isWorkerPage()) return false;
    value = String(value || "").trim();
    if (value === "manual" || value === "best-selling") return true;
    return isCollectionPage() && (value === "most-relevant" || value === "relevance");
  }

  function ensureWorkerSalesRankOption(scope) {
    if (!isWorkerPage()) return;
    var root = scope || document;
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.sorting-filter__options-inner').forEach(function (list, index) {
      if (list.querySelector('input[name="sort_by"][value="sales-rank"]')) return;
      var source = list.querySelector('label');
      if (!source) return;

      var label = source.cloneNode(true);
      var input = label.querySelector('input[name="sort_by"]');
      var option = label.querySelector('[role="option"]');
      var text = label.querySelector('.sorting-filter__label');
      if (!input || !option || !text) return;

      var id = 'bw-sort-sales-rank-' + index + '-' + Math.random().toString(36).slice(2, 8);
      label.htmlFor = id;
      input.id = id;
      input.value = 'sales-rank';
      input.dataset.optionName = 'Sales rank';
      input.checked = false;
      option.setAttribute('aria-selected', 'false');
      option.tabIndex = -1;
      text.textContent = 'Sales rank';

      var bestSelling = Array.from(list.querySelectorAll('label')).find(function (candidate) {
        var candidateInput = candidate.querySelector('input[name="sort_by"]');
        return candidateInput && candidateInput.value === 'best-selling';
      });
      if (bestSelling) bestSelling.insertAdjacentElement('afterend', label);
      else list.appendChild(label);
    });

    root.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      if (select.querySelector('option[value="sales-rank"]')) return;
      var option = document.createElement('option');
      option.value = 'sales-rank';
      option.textContent = 'Sales rank';
      select.appendChild(option);
    });
  }

  function syncSortControls(root) {
    var scope = root || document;
    ensureWorkerSalesRankOption(scope);
    var desired = selectedSort();
    var inputs = Array.from(scope.querySelectorAll('input[name="sort_by"]'));
    if (scope.matches && scope.matches('input[name="sort_by"]')) inputs.unshift(scope);

    inputs.forEach(function (input) {
      var option = input.closest('[role="option"]');
      var label = input.closest('label');
      var unsupportedSort = unsupportedWorkerSort(input.value);
      if (label) label.hidden = unsupportedSort;
      else if (option) option.hidden = unsupportedSort;
      input.disabled = unsupportedSort;
      if (unsupportedSort) {
        input.checked = false;
        return;
      }

      var selected = input.value === desired;
      input.checked = selected;
      if (option) {
        option.setAttribute("aria-selected", selected ? "true" : "false");
        option.tabIndex = selected ? 0 : -1;
      }
    });

    scope.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      Array.from(select.options).forEach(function (option) {
        var hidden = unsupportedWorkerSort(option.value);
        option.hidden = hidden;
        option.disabled = hidden;
      });
      if (Array.from(select.options).some(function (option) { return option.value === desired; })) select.value = desired;
    });
  }

  function key(value) {
    return String(value || "").toLowerCase().replace(/[’']/g, "").replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").trim();
  }

  function cleanText(value) {
    var text = String(value || "").replace(/\s+/g, " ").trim().replace(/^[\s.;:|]+/, "").replace(/[\s;|]+$/, "").trim();
    if (!text || /^(?:n\/?a|none|null|undefined|other|unknown|default|-+)$/i.test(text) || /^\?+$/.test(text)) return "";
    var wrapped = text.match(/^\((.+)\)\.?$/);
    return wrapped ? wrapped[1].trim() : text;
  }

  function cleanPublisher(value) {
    var text = cleanText(value);
    if (!text) return "";
    return /^7\s*Cats Press$/i.test(text) ? "7 Cats Press" : text;
  }

  function cleanCategory(value) {
    return canonicalCategories.get(key(String(value || "").replace(/_/g, " "))) || "";
  }

  function cleanBinding(value) {
    var normalized = String(value || "").toLowerCase().replace(/-/g, " ").replace(/\s+/g, " ").trim();
    return bindingAliases.get(normalized) || bindingAliases.get(String(value || "").toLowerCase().trim()) || "";
  }

  var definitions = [
    { name: "filter.p.m.custom.author", clean: cleanText },
    { name: "filter.p.m.custom.browse_category", clean: cleanCategory },
    { name: "filter.p.m.custom.publisher", clean: cleanPublisher },
    { name: "filter.p.m.custom.binding", clean: cleanBinding }
  ];

  function listItem(input) {
    return input.closest("li") || input.closest(".facets__inputs-list-item") || input.parentElement;
  }

  function labelFor(input) {
    if (!input.id) return null;
    try { return document.querySelector('label[for="' + CSS.escape(input.id) + '"]'); } catch (error) { return null; }
  }

  function polishDefinition(definition, root) {
    var inputs = Array.from(root.querySelectorAll('input[name="' + definition.name + '"]'));
    var groups = new Map();

    if (definition.name === "filter.p.m.custom.binding" && inputs.length) {
      var bindingPanels = new Set(inputs.map(function (input) {
        return input.closest("details") || input.closest(".facets__item");
      }).filter(Boolean));
      bindingPanels.forEach(function (bindingPanel) {
        bindingPanel.dataset.bwBindingPolished = "true";
        bindingPanel.querySelectorAll(".bw-filter-list-search, .show-more__button").forEach(function (element) {
          element.remove();
        });
      });
    }

    inputs.forEach(function (input) {
      var label = definition.clean(input.value);
      var item = listItem(input);
      if (!label) {
        if (item) item.hidden = true;
        return;
      }
      input.dataset.bwCanonicalFacet = label;
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(input);
    });

    groups.forEach(function (group, label) {
      var representative = group.find(function (input) { return input.checked; }) || group[0];
      var anyChecked = group.some(function (input) { return input.checked; });
      group.forEach(function (input) {
        var item = listItem(input);
        if (item) {
          item.hidden = input !== representative;
          item.classList.toggle("bw-native-canonical-visible", input === representative);
        }
      });
      representative.checked = anyChecked;
      var labelNode = labelFor(representative);
      var labelText = labelNode && (labelNode.querySelector(".checkbox__label-text") || labelNode);
      if (labelText && labelText.textContent.trim() !== label) labelText.textContent = label;
    });
  }

  function panelLabel(panel) {
    var label = panel.querySelector(".facets__label, summary, legend");
    return key(label ? label.textContent : "");
  }

  function reorderConditionPanel(panel) {
    if (panelLabel(panel) !== "condition") return;
    var list = panel.querySelector(".facets__inputs-list");
    if (!list) return;

    var ranks = new Map(conditionOrder.map(function (condition, index) {
      return [key(condition), index];
    }));
    var items = Array.from(list.children).filter(function (item) {
      return item.matches("li, .facets__inputs-list-item");
    });

    items.sort(function (a, b) {
      var aInput = a.querySelector('input[type="checkbox"]');
      var bInput = b.querySelector('input[type="checkbox"]');
      var aValue = key(aInput ? (aInput.value || aInput.dataset.label) : a.textContent);
      var bValue = key(bInput ? (bInput.value || bInput.dataset.label) : b.textContent);
      var aRank = ranks.has(aValue) ? ranks.get(aValue) : conditionOrder.length;
      var bRank = ranks.has(bValue) ? ranks.get(bValue) : conditionOrder.length;
      return aRank - bRank || aValue.localeCompare(bValue);
    });

    items.forEach(function (item) { list.appendChild(item); });
  }

  function polish(root) {
    definitions.forEach(function (definition) { polishDefinition(definition, root || document); });
    var scope = root || document;
    var panels = [];
    if (scope.matches && scope.matches("details.facets__panel, .facets__panel")) panels.push(scope);
    if (scope.querySelectorAll) panels = panels.concat(Array.from(scope.querySelectorAll("details.facets__panel, .facets__panel")));
    panels.forEach(reorderConditionPanel);
    ensureWorkerSalesRankOption(scope);
    syncSortControls(scope);
  }

  document.addEventListener("change", function (event) {
    if (event.target.matches('input[name="sort_by"], select[name="sort_by"]')) {
      window.setTimeout(function () { syncSortControls(document); }, 250);
      return;
    }
    var input = event.target.closest('input[data-bw-canonical-facet]');
    if (!input) return;
    var selector = 'input[name="' + input.name + '"][data-bw-canonical-facet="' + CSS.escape(input.dataset.bwCanonicalFacet) + '"]';
    document.querySelectorAll(selector).forEach(function (alias) { alias.checked = input.checked; });
  }, true);

  var scheduled = false;
  var pendingRoots = [];
  function schedulePolish(root) {
    if (root && root.nodeType === 1) pendingRoots.push(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      var roots = pendingRoots.splice(0);
      if (!roots.length) roots = [document];
      roots.forEach(function (candidate) {
        var relevant = definitions.some(function (definition) {
          var selector = 'input[name="' + definition.name + '"]';
          return (candidate.matches && candidate.matches(selector)) || (candidate.querySelector && candidate.querySelector(selector));
        });
        if (!relevant && candidate.querySelector) {
          relevant = Boolean(
            (candidate.matches && candidate.matches('sorting-filter-component, .sorting-filter__options-inner, input[name="sort_by"], select[name="sort_by"]')) ||
            candidate.querySelector('sorting-filter-component, .sorting-filter__options-inner, input[name="sort_by"], select[name="sort_by"]')
          );
        }
        if (!relevant && candidate.querySelector) {
          var panel = candidate.matches && candidate.matches("details.facets__panel, .facets__panel")
            ? candidate
            : candidate.closest && candidate.closest("details.facets__panel, .facets__panel");
          relevant = Boolean((panel && panelLabel(panel) === "condition") || Array.from(candidate.querySelectorAll("details.facets__panel, .facets__panel")).some(function (facetPanel) {
            return panelLabel(facetPanel) === "condition";
          }));
        }
        if (relevant) polish(candidate);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", schedulePolish);
  document.addEventListener("shopify:section:load", schedulePolish);
  window.addEventListener("popstate", function () { syncSortControls(document); });
  function startPolishObserver() {
    var observerRoot = document.documentElement;
    if (!observerRoot || !observerRoot.nodeType) {
      document.addEventListener("DOMContentLoaded", startPolishObserver, { once: true });
      return;
    }
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) { if (node.nodeType === 1) schedulePolish(node); });
      });
    }).observe(observerRoot, { childList: true, subtree: true });
  }
  startPolishObserver();
  schedulePolish();

})();
